import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { Flex, Button, Text } from '@nula/core-ui';

import { useCreditBalance } from '@/lib/billing/use-subscription';
import { formatCreditResetDate } from '@/lib/billing/format';
import { subscriptionTabForWorkspace } from '@/lib/billing/subscription-tab-for-workspace';
import { useUIStore } from '@/stores/use-ui-store';
import styles from './credit-block-action.module.css';

const root = cva(styles.root);

export type CreditBlockActionProps = {
  workspaceType?: 'personal' | 'team';
  className?: string;
};

export function CreditBlockAction({ workspaceType, className }: CreditBlockActionProps) {
  const setSettingsOpen = useUIStore((s) => s.setSettingsOpen);
  // Never gate the refusal on this query: an unresolved balance renders the
  // action without a date rather than delaying the message.
  const { data } = useCreditBalance();
  const resetAt = data?.creditsResetAt;

  return (
    <Flex align="center" gap="xs" className={clsx(root(), className)}>
      <Button
        size="sm"
        variant="text"
        className={styles.upgrade}
        onClick={() => setSettingsOpen(true, subscriptionTabForWorkspace(workspaceType))}
      >
        Upgrade
      </Button>
      <Text className={styles.hint}>
        {resetAt
          ? `to continue, or your credits reset on ${formatCreditResetDate(resetAt)}.`
          : 'to continue.'}
      </Text>
    </Flex>
  );
}
